import * as React from 'react';
import CodeBlock from "@components/codeblock"
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs'
import 'react-tabs/style/react-tabs.css'

const tabOne = '<img class="delayedImg" alt="Facebook" src="https://s7g10.scene7.com/is/image/FGHCommonContent/fghSocialIcon-facebook-2020?$social$" />'
    const tabTwo = '<img class="delayedImg" alt="Twitter" src="https://s7g10.scene7.com/is/image/FGHCommonContent/fghSocialIcon-twitter-2020?$social$" />'
    const tabThree = '<img class="delayedImg" alt="Instagram" src="https://s7g10.scene7.com/is/image/FGHCommonContent/fghSocialIcon-instagram-2020?$social$" />'
    const tabFour = '<img class="delayedImg" alt="Youtube" src="https://s7g10.scene7.com/is/image/FGHCommonContent/fghSocialIcon-youtube-2020?$social$" />'
    const tabFive = '<img class="delayedImg" alt="Pinterest" src="https://s7g10.scene7.com/is/image/FGHCommonContent/fghSocialIcon-pinterest-2020?$social$" />'
    const tabSix = '<img class="delayedImg" alt="Blog" src="https://s7g10.scene7.com/is/image/FGHCommonContent/fghSocialIcon-blog-2020?$social$" />'


export default function TabbedIcons() {
    return (

        <Tabs>
        <TabList>
          <Tab>
          <img src="https://s7g10.scene7.com/is/image/FGHCommonContent/fghSocialIcon-facebook-2020?$social$" alt="Facebook"/>
            Facebook
          </Tab>
          <Tab>
          <img src="https://s7g10.scene7.com/is/image/FGHCommonContent/fghSocialIcon-twitter-2020?$social$" alt="Twitter"/>
            Twitter
          </Tab>
          <Tab>
          <img src="https://s7g10.scene7.com/is/image/FGHCommonContent/fghSocialIcon-instagram-2020?$social$"  alt="Instagram"/>
            Instagram
          </Tab>
          <Tab>
          <img src="https://s7g10.scene7.com/is/image/FGHCommonContent/fghSocialIcon-youtube-2020?$social$"  alt="Youtube"/>
            Youtube
          </Tab>
          <Tab>
          <img src="https://s7g10.scene7.com/is/image/FGHCommonContent/fghSocialIcon-pinterest-2020?$social$"  alt="Pinterest"/>
            Pinterest
          </Tab>
          <Tab>
          <img src="https://s7g10.scene7.com/is/image/FGHCommonContent/fghSocialIcon-blog-2020?$social$" alt="Social"/>
            Blog
          </Tab>
        </TabList>
        <TabPanel>
          <CodeBlock tabbed={true}>{tabOne}</CodeBlock>
        </TabPanel>
        <TabPanel>
          <CodeBlock tabbed={true}>{tabTwo}</CodeBlock>
        </TabPanel>
        <TabPanel>
          <CodeBlock tabbed={true}>{tabThree}</CodeBlock>
        </TabPanel>
        <TabPanel>
          <CodeBlock tabbed={true}>{tabFour}</CodeBlock>
        </TabPanel>
        <TabPanel>
          <CodeBlock tabbed={true}>{tabFive}</CodeBlock>
        </TabPanel>
        <TabPanel>
          <CodeBlock tabbed={true}>{tabSix}</CodeBlock>
        </TabPanel>
      </Tabs>

    )  
  }